module.exports = __webpack_public_path__ + "img/cave38.5d396a52.jpg";